import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  screen: {
    backgroundColor: '$colorBgPrimaryLight',
  },
  layout: {
    flex: 1,
  },
  content: {
    flex: 1,
  },
  rounded: {
    borderRadius: '$borderRadius4',
  },
});
